import { ISchool } from '../../interfaces/school.interface'
import { ISchoolBlog } from './useBlogs'
import {
  Card,
  CardActions,
  CardContent,
  Divider,
  Typography,
} from '@mui/material'
import * as React from 'react'
import Image from 'next/image'
import { useTheme } from '@mui/material/styles'
import ShareSocialDialogButton from '../SocialShare/ShareSocialDialogButton'
import {
  generateArticleUrl,
  getSchoolActiveDomainName,
} from '../../services/utils'
import GoToBlogPostDetailsButton from './GoToBlogPostDetailsButton'

import { Close, Search } from '@mui/icons-material'
import { getNextCardImageSrc } from '../ExtraStyleLogic/cardImages'

export default function BlogPostsListComponent(props: {
  schoolDetails: ISchool
  posts: ISchoolBlog[]
}) {
  const [searchValue, setSearchValue] = React.useState('')
  const [filteredPosts, setFilteredPosts] = React.useState(props.posts)
  const theme = useTheme()
  const [backgroundImage, setBackgroundImage] = React.useState<string>('')

  React.useEffect(() => {
    console.log({ searchValue })
    initiateFilterPosts()
  }, [searchValue])

  React.useEffect(() => {
    setBackgroundImage(getNextCardImageSrc())
  }, [])

  function clearSearch() {
    setSearchValue('')
  }

  function initiateFilterPosts() {
    if (!searchValue) {
      setFilteredPosts(props.posts)
      return
    }
    const localFilteredPosts = props.posts?.filter(post => {
      return searchValue
        ?.toLowerCase()
        ?.split(' ')
        .some(searchItem => {
          return (
            searchItem &&
            (post?.title
              ?.toLocaleLowerCase()
              ?.includes(searchItem?.toLocaleLowerCase()) ||
              post?.preview_post
                ?.toLocaleLowerCase()
                ?.includes(searchItem?.toLocaleLowerCase()))
          )
        })
    })

    setFilteredPosts(localFilteredPosts)
  }

  const handleSearchInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value)
  }

  return (
    <div>
      <div style={{ padding: '30px 20px' }}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            background: '#ffffff',
            padding: '0 10px',
            maxWidth: '400px',
            margin: 'auto',
            borderRadius: '5px',
          }}
        >
          <div>
            <Search
              style={{
                color: '#FC3333',
                cursor: 'pointer',
              }}
            />
          </div>
          <input
            type="text"
            placeholder="Search for an article"
            style={{
              border: '0px',
              outline: '0px',
              width: '100%',
              height: ' 44px',
              background: 'transparent',
              fontSize: '16px',
            }}
            value={searchValue}
            onChange={handleSearchInput}
          />
          <div onClick={clearSearch}>
            <Close />
          </div>
        </div>
      </div>
      <div>
        <Typography
          variant={'h6'}
          align={'center'}
          style={{ color: '#fff', padding: '20px' }}
        >
          Articles
        </Typography>
      </div>
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          width: '100%',
          gap: '20px 10px',
          padding: '20px',
          justifyContent: 'center',
        }}
      >
        {filteredPosts?.map(post => {
          return (
            <div>
              <Card
                style={{ width: '300px', backgroundColor: '#212330' }}
                variant="outlined"
              >
                <div
                  style={{
                    position: 'relative',
                  }}
                >
                  {post.preview_image ? (
                    <Image
                      style={{ objectFit: 'cover' }}
                      objectFit={'cover'}
                      src={post.preview_image}
                      height={'150'}
                      width={'300'}
                      unoptimized={true} // to reduce load on server for now
                      alt="preview image"
                    />
                  ) : (
                    <Image
                      style={{ objectFit: 'cover' }}
                      objectFit={'cover'}
                      src={backgroundImage}
                      height={'150'}
                      width={'300'}
                      unoptimized={true} // to reduce load on server for now
                      alt="placeholder image"
                    />
                  )}
                </div>
                <CardContent
                  style={{
                    height: '150px',
                    overflowY: 'hidden',
                    padding: '10px',
                  }}
                >
                  <div>
                    <Typography
                      gutterBottom={true}
                      style={{ color: '#fff' }}
                      variant={'h6'}
                    >
                      {post.title}
                    </Typography>
                    <Typography style={{ color: '#fff' }} variant={'body2'}>
                      {post.preview_post}
                    </Typography>
                  </div>
                </CardContent>

                <Divider />
                <CardActions>
                  <GoToBlogPostDetailsButton
                    school={props.schoolDetails}
                    post={post}
                  />
                  <span style={{ flexGrow: 1 }} />
                  <ShareSocialDialogButton
                    buttonSize={'small'}
                    label={'Share this link to the post'}
                    url={`https://${getSchoolActiveDomainName(
                      props.schoolDetails,
                    )}${generateArticleUrl(post)}`}
                    title={`You should register now to ${post.title}`}
                    buttonStyle={{
                      color: `${theme.palette.primary.main}`,
                    }}
                  />
                </CardActions>
              </Card>
            </div>
          )
        })}
      </div>
    </div>
  )
}
